import { Component, HostBinding, Input } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { SPINNER_FADEOUT_DURATION } from '../app.constants';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  animations: [
    // Enter only. The exit is driven by the `leaving` class instead, so the fade plays while the
    // caller still holds the spinner mounted - a leave animation would run after the results are
    // already on screen and keep this element taking up space over them.
    trigger('fadeInOut', [
      state('void', style({ opacity: 0 })),
      state('*', style({ opacity: 1 })),
      transition('void => *', animate(`${SPINNER_FADEOUT_DURATION}ms ease-in`)),
    ]),
  ],
  standalone: false,
})
export class LoadingSpinnerComponent {
  // Set for SPINNER_FADEOUT_DURATION before the caller unmounts, so the spinner fades out
  // rather than popping away. See hideListSpinner() in patients.component.ts.
  @Input() @HostBinding('class.is-leaving') leaving = false;
}
